var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control" },
    [
      _c("multiselect", {
        class: { error: _vm.error },
        attrs: {
          label: "title",
          "track-by": "id",
          placeholder: _vm.placeholder,
          options: _vm.facilities,
          searchable: true,
          "internal-search": false,
          loading: _vm.isFetching,
          "options-limit": 20,
          "clear-on-select": false,
          limit: 3,
          "max-height": 200,
          "show-no-results": false,
        },
        on: { "search-change": _vm.listingFind, remove: _vm.removed },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }